import { Badge } from 'gql/autogen/Badge';
import { ActivityBadgeCategory, ActivityBadgeCategoryProps } from 'component/common/Badge/BadgeService.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectCurrencyCodeFromBootstrap, selectLocaleFromBootstrap } from 'store/slice/bootstrap';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';

export interface OwnProps {
    badges: Badge[];
    activityId: number;
    badgeCategory: ActivityBadgeCategory;
    isBVariant?: boolean;
    overrideCategoryProps?: ActivityBadgeCategoryProps;
    supplierId?: number;
}

export interface StateProps {
    cms: CmsValue;
    screenSize: ScreenSize;
    isPageContainerSpacing: boolean;
    locale: string;
    currency: string;
}

export type ActivityCardBadgeComponentProps = StateProps & OwnProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectScreenSize,
    selectLocaleFromBootstrap,
    selectCurrencyCodeFromBootstrap,
    (cms, screenSize, locale, currency): StateProps => {
        const isPageContainerSpacing = isOn(FeatureName.PageContainerSpacing);
        return {
            cms,
            screenSize,
            isPageContainerSpacing,
            locale,
            currency,
        };
    },
);
